import React from 'react';
const DownloadFileSVG = ({ color = 'black', className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
    >
      <path
        d="M6.33987 9.27298C6.25242 9.36861 6.12885 9.42308 5.99925 9.42308C5.86965 9.42308 5.74608 9.36861 5.65864 9.27298L3.19709 6.58068C3.02509 6.39255 3.03816 6.10062 3.22628 5.92862C3.41441 5.75662 3.70634 5.76966 3.87834 5.95778L5.53771 7.77274V0.961538C5.53771 0.70664 5.74436 0.5 5.99925 0.5C6.25414 0.5 6.46079 0.70664 6.46079 0.961538V7.77274L8.12017 5.95778C8.29217 5.76966 8.58411 5.75662 8.77224 5.92862C8.96036 6.10062 8.97341 6.39255 8.80141 6.58068L6.33987 9.27298Z"
        fill={color}
      />
      <path
        d="M0.923077 8.34606C0.923077 8.09117 0.716443 7.88452 0.461539 7.88452C0.20664 7.88452 3.22432e-07 8.09117 3.22432e-07 8.34606V8.37984C-1.19853e-05 9.22144 -2.4337e-05 9.89978 0.0717049 10.4333C0.146179 10.9872 0.305496 11.4536 0.675908 11.824C1.04632 12.1944 1.5127 12.3538 2.06662 12.4282C2.60014 12.4999 3.27849 12.4999 4.12008 12.4999H7.87994C8.72154 12.4999 9.39988 12.4999 9.93341 12.4282C10.4873 12.3538 10.9537 12.1944 11.3241 11.824C11.6945 11.4536 11.8538 10.9872 11.9283 10.4333C12 9.89978 12 9.22144 12 8.37984V8.34606C12 8.09117 11.7934 7.88452 11.5385 7.88452C11.2836 7.88452 11.0769 8.09117 11.0769 8.34606C11.0769 9.22938 11.0759 9.84544 11.0135 10.3103C10.9527 10.7619 10.8417 11.001 10.6714 11.1713C10.501 11.3416 10.262 11.4526 9.8104 11.5134C9.34554 11.5758 8.72948 11.5768 7.84615 11.5768H4.15385C3.27052 11.5768 2.65444 11.5758 2.18961 11.5134C1.73806 11.4526 1.49894 11.3416 1.32862 11.1713C1.15831 11.001 1.04726 10.7619 0.986554 10.3103C0.924056 9.84544 0.923077 9.22938 0.923077 8.34606Z"
        fill={color}
      />
    </svg>
  );
};

export default DownloadFileSVG;
